<template>
  <div class="tableDiv" :style="{ height: options.tableHeight + 'px' }">
    <el-table
      :data="list"
      border
      stripe
      fit
      style="width: 100%"
      :max-height="options.tableHeight"
      @selection-change="handleSelectionChange"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="no-data">
          <i class="crm-wu"></i>
          <span class="text-1">{{ options.errortip }}</span>
        </div>
      </template>
      <el-table-column
        type="selection"
        align="center"
        :selectable="checkboxInit"
        style="width: 55px"
        v-if="options.mutiSelect"
      ></el-table-column>

      <!--endregion-->
      <!-- 编辑列start -->
      <template v-for="(column, $index) in columns">
        <template v-if="column.isfixed">
          <el-table-column
            :prop="column.prop"
            :key="$index"
            :fixed="column.fixed"
            :label="column.label"
            :align="column.align"
            :show-overflow-tooltip="true"
            min-width="150px"
            v-if="column.isShow"
          >
            <template slot-scope="scope">
              <!-- client_actisagree   活动录入是否同意后期使用  0 不同意  1 同意 -->
              <el-button
                v-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, scope.row)"
              >
                {{ list[scope.$index][column.prop] }}
                <i
                  v-if="
                    options.isShowPersonInfo &&
                    column.isShowRule == '1' &&
                    scope.row.client_actisagree == '0'
                  "
                  class="crmIcon-ysbh mr5"
                ></i>
                <!--isschoolread  是否已读  1是  0 否 -->
                <span
                  v-if="column.isReadStatus && scope.row.client_isnewtip == '1'"
                  class="no-readTips"
                  >{{ $t("Table.noreadTips") }}</span
                >
              </el-button>

              <span v-else type="text">
                {{ list[scope.$index][column.prop] }}
                <i
                  v-if="
                    options.isShowPersonInfo &&
                    column.isShowRule == '1' &&
                    scope.row.client_actisagree == '0'
                  "
                  class="crmIcon-ysbh mr5"
                ></i>
              </span>
            </template>
          </el-table-column>
        </template>
        <template v-else-if="column.istag">
          <el-table-column
            :prop="column.prop"
            :key="`${Math.random()}-${$index}`"
            :fixed="column.fixed"
            :label="column.label"
            :align="column.align"
            :show-overflow-tooltip="true"
            min-width="180px"
          >
            <template slot-scope="scope">
              <div class="table-tags-list">
                <el-tag
                  class="tag-sty"
                  v-for="(item, index) in list[scope.$index][column.prop]"
                  :key="index"
                  >{{ item }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            :prop="column.prop"
            :key="$index"
            :label="column.label"
            :align="column.align"
            :show-overflow-tooltip="true"
            min-width="150px"
            v-if="column.isShow"
          >
            <template slot-scope="scope">
              <div
                v-if="column.iscode"
                class="table-code"
                @click="handleCodeChange(scope.$index, scope.row, column)"
              >
                <img :src="list[scope.$index][column.prop]" />
              </div>
              <template v-else-if="!column.islevel">
                <template v-if="list[scope.$index][column.prop]">
                  {{ list[scope.$index][column.prop] }}
                  <span
                    v-if="column.isTypeTab"
                    class="phone-tips"
                    :class="{ 'field-phone': scope.row.isoutmobile == 1 }"
                  >
                    {{
                      scope.row.isoutmobile == 1
                        ? $t("Table.label_text3")
                        : $t("Table.label_text4")
                    }}
                  </span>
                </template>
                <template v-else>--</template>
              </template>
              <span v-else>
                <i
                  v-for="n in Number(list[scope.$index][column.prop])"
                  :key="n"
                  class="icon-heart-off"
                ></i>
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 编辑列end -->
      <!--region 按钮操作组-->
      <!-- 下拉操作组 -->
      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        width="150px"
        :fixed="operates.fixed"
        v-if="
          operates.dropDown &&
          operates.list.filter((_x) => _x.show === true).length > 0
        "
      >
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            @visible-change="dropdownClick(scope.row)"
          >
            <span class="el-dropdown-link">
              <span style="color: #20a8d8">{{ $t("Common.workMenu") }}</span>
              <i class="el-icon-arrow-down el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(btn, key) in operates.list">
                <el-dropdown-item
                  v-if="
                    (btn.dependOnPower && postbe_crmlevel == '1') ||
                    !btn.dependOnPower
                  "
                  :key="key"
                  divided
                  :command="btn.name"
                  >{{ btn.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        ref="fixedColumn"
        :label="operates.label"
        :align="operates.align"
        :width="operates.width"
        :fixed="operates.fixed"
        v-else-if="operates.list.filter((_x) => _x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <template v-for="(btn, key) in operates.list">
            <div
              class="item"
              v-if="btn.show && scope.row.is_visit_autition"
              :key="key"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '1'"
              ></el-button>
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '0'"
                >{{ btn.label }}</el-button
              >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.is_visit_autition == '-1'"
              ></el-button>
            </div>
            <div class="item" v-if="btn.show && btn.noPermission" :key="key">
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="
                  postbe_crmlevel == '1' &&
                  scope.row.client_distributionstatus == '0'
                "
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="btn.show && btn.ischaserlapsed && postbe_crmlevel == '1'"
              :key="key"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.client_ischaserlapsed != '1'"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="btn.show && btn.is_active_del && postbe_crmlevel == '1'"
              :key="key"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.activity_type != '1'"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="
                btn.show &&
                companyIsmajor == '2' &&
                btn.is_active_copy &&
                postbe_crmlevel == '1'
              "
              :key="key"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-if="
                btn.show && btn.floowMe && scope.row.client_distributionstatus
              "
              :key="key"
            >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-if="scope.row.client_distributionstatus == '0'"
                >{{ btn.label }}</el-button
              >
            </div>
            <div
              class="item"
              v-else-if="
                btn.show &&
                !scope.row.is_visit_autition &&
                !btn.noPermission &&
                !btn.ischaserlapsed &&
                !btn.floowMe &&
                !btn.is_active_del &&
                !btn.is_active_copy
              "
              :key="key"
            >
              <!-- 意向客户跟进开始 -->
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                class="btn-noclick"
                v-if="scope.row.client_forbid == 0 && btn.Customfloow"
                >{{ btn.label }}</el-button
              >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                :disabled="btn.disabled"
                v-else-if="btn.Customfloow"
                >{{ btn.label }}</el-button
              >
              <!-- 意向客户跟进结束 -->
              <!-- 意向客户转正 -->
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                v-else-if="
                  btn.turnPositive &&
                  scope.row.client_tracestatus != 4 &&
                  scope.row.client_tracestatus != -1 &&
                  scope.row.is_positive != 0
                "
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
              <!-- 删除重复名单 -->
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                v-else-if="btn.delRepeat"
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
              <!-- && parseInt(scope.row.is_repeat) > 0 -->
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                v-else-if="btn.trunSchool && postbe_crmlevel == '1'"
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
              <el-button
                @click.native.prevent="btn.method(key, scope.row)"
                :type="btn.type"
                size="small"
                v-else-if="
                  !btn.turnPositive && !btn.delRepeat && !btn.trunSchool
                "
                :disabled="btn.disabled"
                >{{ btn.label }}</el-button
              >
            </div>
          </template>
        </template>
      </el-table-column>
      <!-- 意向各户***排序方式 -->
      <el-table-column
        v-if="isSort"
        class="column-sort"
        :fixed="tableSort.fixed"
        :label="tableSort.label"
        :align="tableSort.align"
        width="40px"
      >
        <template slot="header" slot-scope="scope">
          <el-dropdown class="btn-sort" @command="handleCommandSort">
            <span class="el-dropdown-link">
              <i class="icon-sort"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in tableSort.sortOption"
                :key="item.field"
                divided
                :command="item.field"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <!-- 自定义列 -->
      <el-table-column
        v-if="issetting"
        :fixed="tableOperate.fixed"
        :label="tableOperate.label"
        :align="tableOperate.align"
        width="40px"
        :render-header="renderHeader"
      >
        <!-- <template slot-scope="scope"></template> -->
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "tableList",
  props: {
    total: Number, //分页数据
    pagesize: Number, //分页条数
    issetting: null, //是否可编辑列
    isSort: null, //是否显示排序方式
    list: {
      type: Array,
      // default: []
    }, // 数据列表
    isCheckbox: null,
    isPagination: null,
    columns: {
      type: Array,
      // default: []
    }, // 需要展示的列 === prop：列数据对应的属性，label：列名，align：对齐方式，width：列宽
    operates: {}, // 操作按钮组 === label: 文本，type :类型（primary / success / warning / danger / info / text），show：是否显示，icon：按钮图标，plain：是否朴素按钮，disabled：是否禁用，method：回调方法
    options: {
      type: Object,
      // default: {
      //   highlightCurrentRow: false // 是否要高亮当前行
      // }
    }, // table 表格的控制参数
    tableOperate: {
      type: Object,
    },
    tableSort: {
      type: Object,
    },
  },
  data() {
    return {
      currentPage: 1,
      num: 10,
      size: 10,
      postbe_crmlevel: "", // 权限判断
    };
  },
  created() {
    this.num = this.total;
    this.size = this.pagesize;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    // this.tableHeight=parseInt(this.getClientHeight());
  },
  watch: {
    total() {
      this.num = this.newdata;
    },
    pagesize() {
      this.size = this.newdata;
    },
  },
  computed: {
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v) {
      this.$emit("handleColumnChange", k, v);
    },
    handleCodeChange(k, v, col) {
      this.$emit("handleCodeChange", k, v, col);
    },
    // 点击功能菜单***8获取每条数据
    dropdownClick(row) {
      this.$emit("dropdownClick", row);
    },
    // 点击功能菜单
    handleCommand(command) {
      this.$emit("handleCommand", command);
    },
    // 点击排序方式***功能菜单
    handleCommandSort(command) {
      this.$emit("handleCommandSort", command);
    },
    renderHeader(h, { column, $index }) {
      return h("span", {
        class: "el-icon-setting",
        on: {
          click: () => {
            this.$emit("toggleEditableColumn");
          },
        },
      });
    },
    checkboxInit(row) {
      return 1;
    },
  },
};
</script>

<style lang="less">
.item {
  display: inline-block;
  .btn-noclick {
    color: #aaa;
  }
}

.item + .item {
  margin-left: 15px !important;
}

.link-type {
  font-weight: normal;
}

.table-code {
  width: 40px;
  margin: 0 auto;

  img {
    width: 100%;
  }
}

.el-icon-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 18px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}
.el-tooltip__popper.is-dark {
  max-width: 500px;
}

// 排序方式
.btn-sort {
  padding: 0px !important;
  .icon-sort {
    display: block;
    width: 15px;
    height: 15px;
    cursor: pointer;
    background: url("../../assets/images/icon/sort.svg") no-repeat;
    background-size: 100% 100%;
  }
}
.column-sort {
}
.tableDiv {
  .phone-tips {
    display: inline-block;
    width: 30px;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    background: rgba(39, 170, 216, 0.15);
    border-radius: 2px;
    color: #27aad8;
    margin-left: 4px;
    &.field-phone {
      background: rgba(252, 84, 104, 0.15);
      color: #fb586c;
    }
  }
  .no-readTips {
    display: inline-block;
    width: 30px;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    background: rgba(252, 84, 104, 0.15);
    color: #fb586c;
    border-radius: 2px;
    margin-left: 4px;
  }
}
</style>
